module.exports = __webpack_public_path__ + "static/media/touchClick.7dd50528.svg";